<template>
  <div class="test-polygon-container">
    <canvas id="quad" width="1500" height="1000" style="background: antiquewhite"></canvas>
    <canvas id="myCanvas" width='500' height='500'></canvas>
  </div>
</template>

<script type="text/ecmascript-6">
  export default{
    data(){
      return {}
    },

    computed: {},

    created(){
    },

    mounted(){
      var myCanvas = document.getElementById("myCanvas");
      var context = myCanvas.getContext("2d");
      function drawPath(x, y, n, r) {
        var i, ang;
        ang = Math.PI * 2 / n //旋转的角度
        context.save();//保存状态
        context.fillStyle = 'rgba(255,0,0,.3)';//填充红色，半透明
        context.strokeStyle = 'hsl(120,50%,50%)';//填充绿色
        context.lineWidth = 1;//设置线宽
        context.translate(x, y);//原点移到x,y处，即要画的多边形中心
        context.moveTo(0, -r);//据中心r距离处画点
        context.beginPath();
        for (i = 0; i < n; i++) {
          context.rotate(ang)//旋转
          context.lineTo(0, -r);//据中心r距离处连线
        }
        context.closePath();
        context.stroke();
        context.fill();
        context.restore();//返回原始状态
      }
      drawPath(100, 100, 5, 40)//在100,100处画一个半径为40的五边形
      drawPath(200, 100, 3, 40)//在200,100处画一个半径为40的三角形
      drawPath(300, 100, 7, 40)//在300,100处画一个半径为40的七边形
      drawPath(100, 200, 15, 40)//在100,200处画一个半径为40的十五边形
      drawPath(200, 200, 4, 40)//在100,200处画一个半径为40的四边形




      function polygon(poly, context) {
        context.beginPath();
        context.moveTo(poly[0], poly[1]);
        for (var i = 2; i < 8; i += 2) {
          context.lineTo(poly[i], poly[i + 1]);
          console.log(poly[i], poly[i + 1]);
        }
        context.closePath();
        context.fill();
        context.stroke();
      }
      // 获得 canvas.context
      var canvas = document.getElementById("quad");
      var context = canvas.getContext("2d");
      context.fillStyle = "rgba(255,0,0,0.1)"; // 内部使用白色，如不指定，默认为黑色
      context.strokeStyle = "#008"; // 深蓝色外边框
      context.lineWidth = 2; // 2个像素宽
      var poly = [0, 416, 529, 424, 639, 499, 52, 490];
      polygon(poly, context);
    },

    methods: {},

    components: {}
  }
</script>

<style lang="less" rel="stylesheet/less">
  .test-polygon-container {
    width: 100%;
    min-height: 500px;
    height: auto;
    display: flex;
    align-items: stretch;
    padding: 15px;
    flex-direction: column;
  }
</style>
